
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './LandingPage';
import Login from './Login';
import About from './About';
import Manuscript from './Manuscript';
import PublishedArticles2 from './PublishedArticles2';
import Admin from './Admin';
import Register from './Register';
import AuthorPush from './AuthorPush';
import EditorInfo from './EditorInfo';
import ViewAuthorSubmission from './ViewAuthorSubmission';
//import Message from './Message';


function App() {
  return (
    <Router>
      
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/submit" element={<Manuscript />} />
        <Route path="/published" element={<PublishedArticles2 />} />
         <Route path="/admin" element={<Admin />} />
         <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
         <Route path="/authorpush" element={<AuthorPush />} />
        <Route path="/editorinfo" element={<EditorInfo />} />
        <Route path="/viewauthorsubmission" element={<ViewAuthorSubmission />} />


        
      </Routes>
    </Router>
  );
}

export default App;
